var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Arrow pointing down",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.467 17.94V3.75a.75.75 0 0 1 1.5 0v14.19l6.186-6.187a.75.75 0 1 1 1.061 1.061l-7.467 7.467a.75.75 0 0 1-.311.187h-.002a.7.7 0 0 1-.2.032H12.2a.7.7 0 0 1-.2-.032h-.001a.75.75 0 0 1-.311-.187L4.22 12.814a.75.75 0 1 1 1.06-1.061z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;